<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col :span="12">
        <div
          style="background: #f3f3f3;height: 30px;line-height:30px;padding: 0 25px;display: flex; align-items: center;"
        >
          <div>筛选查询</div>
        </div>
        <el-collapse-transition>
          <div style="padding: 10px 25px;">
            <el-form
              :inline="true"
              :model="searchForm"
              class="demo-form-inline"
            >
              <el-form-item label="输入搜索：">
                <el-input
                  v-model="searchForm.name"
                  placeholder="改标人员名称"
                  @keyup.native.enter="fetchData"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchForm.code"
                  placeholder="改标人员编码"
                  @keyup.native.enter="fetchData"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="fetchData">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row class="filter">
      <el-col :span="12" style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          <div>改标人员列表：</div>
          <el-button
            style="margin-left: auto;"
            type="success"
            size="mini"
            @click="showGbDiaLog"
            >添加</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0;">
          <el-table
            ref="multipleTable"
            :data="resData.list"
            tooltip-effect="dark"
          >
            <el-table-column
              prop="id"
              label="序号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="改标人员名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="code"
              label="改标人员编码"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              width="160px"
              align="center"
            ></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editGbUser(scope.row)"
                  >编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right;padding: 25px;">
          <el-pagination
            :current-page.sync="page"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="diaLogTitle"
      :visible.sync="gbUserFormVisible"
      width="30%"
      :before-close="handleGbUserClose"
      center
    >
      <el-form :model="form" label-width="110px">
        <el-form-item label="改标人员编码" required>
          <el-input
            v-model="form.code"
            size="mini"
            :readonly="readonly"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
        <el-form-item label="改标人员名称" required>
          <el-input v-model="form.name" size="mini"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleGbUserClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="saveGbUser"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HeaderTabs from "../wavepicking/components/HeaderTabs";
export default {
  name: "GbUserSetting",
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      loading: false,
      resData: {},
      diaLogTitle: "新建改标人员",
      gbUserFormVisible: false,
      form: {
        id: null,
        name: "",
        code: "",
      },
      searchForm: {},
      resData: {},
      page: 1,
      pagesize: 10,
      count: 0,
      readonly: false,
      disabled: false,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http
        .post("/erp/GaiBiao/getGbUserList", {
          page: this.page,
          pagesize: this.pagesize,
          code: this.searchForm.code,
          name: this.searchForm.name,
        })
        .then(res => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
          }
        });
    },
    saveGbUser() {
      this.$http
        .post("/erp/GaiBiao/saveGbUser", this.filteredForm)
        .then(res => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.gbUserFormVisible = false;
            this.fetchData(true);
            this.form = {
              id: null,
              code: "",
              name: "",
            };
            this.$message.success("操作成功");
          }
        });
    },
    showGbDiaLog() {
      this.gbUserFormVisible = true;
      this.readonly = false;
      this.disabled = false;
      this.diaLogTitle = "新建改标人员";
    },
    editGbUser(row) {
      this.gbUserFormVisible = true;
      this.diaLogTitle = "编辑改标人员";
      this.disabled = true;
      this.readonly = true;
      this.form = {
        id: row.id,
        code: row.code,
        name: row.name,
      };
    },
    handleGbUserClose() {
      this.form = {
        id: null,
        code: "",
        name: "",
        piece_coefficient: "",
      };
      this.gbUserFormVisible = false;
      this.readonly = false;
      this.disabled = false;
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchData();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/GaiBiao/GbUserSetting.vue